import { arrayUnion } from "firebase/firestore";
import { formatItem, formatTimeAmPm, formatTypes } from "global/common/dateFormatting";
import { gEnums } from "global/enums/globalEnums";
import { createRefPath, createRefPath_event } from "global/firestoreData/appData/appRefPaths";
import { dataFix } from 'global/common/dataFix';
import { ParentContext } from "../ParentContext";
import { useAppUserAccess } from "./useAppUserAccess";
import { getBaseRef } from "global/firestoreData/helpers/getBaseRef";
import { useCallback, useContext } from "react";
import { getSendNotificationProps } from "global/functions/fbScheduledNotifications";
import { _notificationsCollection } from "global/firestoreData/notifications/notificationsData";

const _allowNotificationsUpdates = true

const dbCallTypes = {
  notifications: 'notifications',
};

export const useNotifications = () => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { currentSettings_state, paps_state, eventInfo_state } = states
  const { pathViews } = paps_state ?? {}
  const { database_fns, page_fns } = fns
  const { getGviDeps } = page_fns ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appNotifications } = aps_global ?? {}
  const { notificationTargets, allowNotificationTopics } = appNotifications ?? {}

  const { appProfileData, staticViews } = eventInfo_state ?? {}

  const appUserAccess = useAppUserAccess()

  const updateNotificationsDirect = useCallback((notification, response_data, callback) => {

    const { clients: clientKey, events: eventKey } = pathViews ?? {}
    const { id: notificationId } = notification ?? {}

    const { result, success } = response_data ?? {}
    const { response_multicast, failedTokens } = result ?? {}
    const { failureCount, successCount } = response_multicast ?? {}

    let _data;

    if (success) {
      _data = { sent: success, readBy: [], sentDate: new Date(), sendData: { failedTokens: failedTokens && failedTokens.length > 0 ? failedTokens : 'none', failureCount: failureCount ? failureCount : 0, successCount: successCount ? successCount : 0 } }
    } else {
      _data = { sent: false }
    }

    if (notification && clientKey && eventKey && notificationId) {
      const _setRef = createRefPath_event(pathViews, [_notificationsCollection, notificationId])
      database_fns.set_doc(_setRef, _data, true, callback)
    }
  }, []);

  /**
   * Updates/creates a notification in the database
   * @param {object} pathViews 
   * @param {object} page_fns 
   * @param {object} notification 
   * @param {object} activeNote 
   * @param {function} callback 
   */
  const updateNotifications = useCallback((notification, activeNote, callback) => {

    if (notification && getGviDeps) {

      dataFix.removeAllEmpties(notification)

      const viDeps = getGviDeps(_notificationsCollection)
      const baseRef = getBaseRef(viDeps, pathViews)
      const { refPath } = baseRef
      const _editRef = activeNote ? createRefPath([_notificationsCollection, activeNote.id], refPath) : createRefPath([_notificationsCollection], refPath)
      delete notification.notificationRecipients
      delete notification.currentGroupKey
      delete notification.appUserCollection
      delete notification.appUserViewTypeProp
      const _notification = dataFix.removeUnderscoreKeys(notification)

      // add or update 
      if (_notification.notificationScheduleType === gEnums.notificationScheduleTypes.direct) {
        const currentDate = new Date()
        _notification.active = true
        _notification.sent = true
        _notification.sendDate = formatItem(formatTypes.shortestDate, currentDate)
        _notification.sendTime = formatTimeAmPm(currentDate.getHours() + ':' + currentDate.getMinutes())
      }
      if (_allowNotificationsUpdates) {
        if (activeNote) {
          database_fns.set_doc(_editRef, _notification, true, callback)
        } else {
          database_fns.add_doc(_editRef, _notification, callback)
        }
      } else {
        callback(notification)
      }
    }
  }, []);

  const updateMarkAsRead = useCallback((pathViews, noteId, callback) => {

    if (noteId) {

      const { uid } = appUserAccess ?? {}

      if (uid) {
        const viDeps = getGviDeps(_notificationsCollection)
        const baseRef = getBaseRef(viDeps, pathViews)
        const { refPath } = baseRef
        const _editRef = createRefPath([_notificationsCollection, noteId], refPath)
        const data = { readBy: arrayUnion(uid) }
        // database_fns.update_doc(_editRef, data, callback)
        database_fns.update_docc({
          refPath: _editRef,
          data: data,
          callback
        })
      }
    }
  }, []);

  const removeNotification = useCallback((noteId, dispatch, callback) => {

    if (noteId) {
      const viDeps = getGviDeps(_notificationsCollection)
      const baseRef = getBaseRef(viDeps, pathViews)
      const { refPath } = baseRef

      // add or update
      const _deleteRef = createRefPath([_notificationsCollection, noteId], refPath)
      database_fns.delete_doc(_deleteRef, callback ? callback : dispatch)
    }
  }, []);

  const sendNotification = useCallback((activeNote, notification, callback) => {
    console.log('activeNote', activeNote)
    const handleSuccess = () => {

    }

    if (activeNote) {
      const np = getSendNotificationProps(activeNote, appUserAccess, handleSuccess, notification, page_fns, pathViews, appProfileData, allowNotificationTopics)
      console.log('np', np)
    }
  }, []);

  const updateScheduledNotifications = useCallback((dataUpdate, pathViews, callback) => {
    if (dataUpdate && pathViews) {
      const _pathKey = 'clients_' + pathViews.clients + '_events_' + pathViews.events
      const _refPath = createRefPath(['notificationSchedules', _pathKey])
      callback()
      // database_fns.set_doc(_refPath, dataUpdate, false, callback)
    }
  }, []);

  return {
    removeNotification,
    updateNotifications,
    updateNotificationsDirect,
    updateMarkAsRead,
    sendNotification,
    updateScheduledNotifications
  };

};
